import React, { useEffect, useState, useContext } from "react";
import { IFileSystem } from "../types";
import { Auth } from "../../../contexts/ridersUserContext";
import { useProjectResourcesStore } from "../../../contexts/project-resources.store";

import { message, notification } from "antd";

import axios from "axios";
import moment from "moment";

import * as git from "isomorphic-git";
import http from "isomorphic-git/http/web";
import { getCookie } from "../../shared/Cookie";
import * as nodepath from "@isomorphic-git/lightning-fs/src/path";
import _, { forEach, set, debounce } from "lodash";
import { isInTimeMs } from "../../../utils";
import {
  idleShutDown,
  publishBranch,
  pushFileToS3,
  storagePush,
} from "../../../api";
import { findPath } from "../../../utils/findPath";
import { Screen } from "./Screen";
import { extractSourceCodes } from "../../../utils/extractSourceCodes";
import messages from "../../../translations";
import { FormattedMessage } from "react-intl";
import yaml from "js-yaml";
import { v4 as uuidv4 } from "uuid";
import { isPublicProject } from "../../../utils/publicProjects";

export const FileContext = React.createContext({});

export const FileSystem: IFileSystem = ({ children, LFS, base_path, uid }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [notsApi, notsContextHolder] = notification.useNotification();
  const [clearStorage, setClearStorage] = useState<any>(false);
  const [inProcess, setInProcess] = useState(false);
  const [documentRefreshKey, setDocumentRefreshKey] = useState(uuidv4());
  const [s3Storage, setS3Storage] = useState<boolean>(false);

  const {
    writeFile: writeProjectFile,
    readFile: readProjectFile,
    deleteFile: deleteProjectFile,
    listFiles: listProjectFiles,
    initResources,
  } = useProjectResourcesStore();

  const {
    user,
    project,
    mode,
    setLoading,
    shutDown,
    setShutDown,
    accessTokenKey,
    userCodeFilePath,
    language,
    yamlData,
    yamlInit,
    setYamlData,
    config,
    contentId,
    setHaveOverrides,
    setContentEditMode,
    setModifiedNotification,
    isBranchOwner,
    setModifiedFiles,
    modifiedFiles,
  } = useContext<any>(Auth.context);

  const [isFileSystemReady, setFileSystemReady] = useState(false);
  const [lastCommitHash, setLastCommitHash] =
    useState<string>("git-not-available");

  useEffect(() => {
    if (yamlInit === false) {
      return;
    }

    if (userCodeFilePath === "" || userCodeFilePath === undefined) {
      console.log("File System Not Ready: " + userCodeFilePath);
      return;
    }
    if (project.dev === "none") {
      setFileSystemReady(true);
      window.fileSystemReady = true;
      return;
    }
    (async () => {
      try {
        if (project.git_address.startsWith("s3://")) {
          setS3Storage(true);
          await initResources(accessTokenKey, {});
        }

        if (project.storage === "none" && !isPublicProject()) {
          git_init();
        }

        if (
          project.storage !== "none" &&
          user.id &&
          !project.git_address.startsWith("s3://")
        ) {
          indexedDB.databases().then((dbs) => {
            dbs.forEach((db) => {
              const [fs_from, fs_user, fs_session, , fs_mode, fs_unix] =
                db.name!.split("_");

              if (fs_from === user.userFrom && fs_user === user.id.toString()) {
                // if (fs_mode === "preview") {
                //   if (parseInt(uid) - parseInt(fs_unix) > 60 * 60 * 3) {
                //     indexedDB.deleteDatabase(db.name!);
                //   }
                // } else {
                //   if (uid !== fs_unix) {
                //     indexedDB.deleteDatabase(db.name!);
                //   }
                // }

                if (uid !== fs_unix && fs_session === project.session_id) {
                  indexedDB.deleteDatabase(db.name!);
                }

                if (
                  user.userFrom === "riders" &&
                  !project.activeSessionList.includes(fs_session)
                ) {
                  indexedDB.deleteDatabase(db.name!);
                }
              }
            });
          });

          if (project.storage === "git") {
            await git_clone(project.git_address, project.git_branch);

            const { sha: hash, message } = await git_get_last_commit_info();
            if (message.startsWith("_")) {
              const [_, username, filesString] = message.split(":");
              const files = filesString.split(",");
              setModifiedFiles(files);
              if (username.trim() !== user.username.trim() && isBranchOwner) {
                setModifiedNotification(username);
              }
            }
            setLastCommitHash(hash);
          } else {
            await git_init();
          }

          for (const file of project.files) {
            if (typeof file === "string") {
              const response = await axios.get(
                project.storage_address + "/" + file
              );
              await writeFile(findPath(file), response.data);
            }
          }

          if (project.storage === "s3") {
            git_add("/");
            const sha = await git_commit("auto commit by riders");
            setLastCommitHash(sha);
          }
        }

        await makeDir("/tmp");

        const yamlO = await readFile(".editor/layouts.yaml");

        if (yamlO) {
          setHaveOverrides(true);
          setYamlData(
            yaml.load(yamlO) || {
              screens: [],
            }
          );
        }

        const sources = extractSourceCodes(yamlData) || [];

        if (project.dev === "blockly") {
          for (const source of sources) {
            await writeFile(
              `${source.sourceXml}.xml`,
              source.defaultXml ||
              project.defaultXml ||
              '<xml xmlns="https://developers.google.com/blockly/xml"></xml>',
              false
            );
          }
        }

        if (["ino", "cpp"].includes(language)) {
          for (const source of sources) {
            await writeFile(
              `usercode/${source.sourceCode}.ino`,
              source.defaultCode ||
              project.defaultCode ||
              "# Your code goes here.",
              false
            );
          }
        } else {
          for (const source of sources) {
            await writeFile(
              `usercode/${source.sourceCode}.py`,
              source.defaultCode ||
              project.defaultCode ||
              "# Your code goes here.",
              false
            );
          }
        }

        window.fileSystemReady = true;
        setFileSystemReady(true);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [yamlInit]);

  const debounceGitSyncHandler = debounce(async () => {
    await gitSyncHandler(
      [
        "usercode",
        "blockly.xml",
        "blockly2.xml",
        "blockly3.xml",
        "blockly4.xml",
        "blockly5.xml",
        "blockly6.xml",
        "blockly7.xml",
        "blockly8.xml",
        "blockly9.xml",
        "blockly10.xml",
        "tmp",
        ".editor",
      ],
      true
    );
  }, 5000);

  const leaveHandler = async (event?: any) => {
    if (inProcess) {
      debounceGitSyncHandler.cancel();

      if (event) {
        event.preventDefault();
        event.returnValue = "Değişikliklerinizi kaydettiniz mi?";
      }

      messageApi.open({
        key: "leave",
        type: "loading",
        content: "Your changes are being saved",
        duration: 3,
        className: "messagebox",
      });

      await gitSyncHandler(
        ["usercode", "blockly.xml", "blockly2.xml", "blockly3.xml"],
        true
      );

      messageApi.open({
        key: "leave",
        type: "success",
        content: "Your changes are saved",
        duration: 3,
        className: "messagebox",
      });

      return event?.returnValue || "";
    }
  };

  useEffect(() => {
    if (isFileSystemReady === false) {
      return;
    }
    if (Boolean(shutDown) || mode !== "editor" || project.dev === "none") {
      return;
    }
    if (inProcess) {
      debounceGitSyncHandler();

      window.addEventListener("beforeunload", leaveHandler);

      if (project.dev === "blockly") {
        window.addEventListener("blocklyChange", debounceGitSyncHandler);
      } else {
        window.addEventListener("keypress", debounceGitSyncHandler);
      }
      return () => {
        window.removeEventListener("keypress", debounceGitSyncHandler);
        window?.removeEventListener("blocklyChange", debounceGitSyncHandler);
        window.removeEventListener("beforeunload", leaveHandler);
      };
    }
  }, [isFileSystemReady, shutDown, mode, project, lastCommitHash, inProcess]);

  useEffect(() => {
    isFileSystemReady && setLoading(false);

    if (isFileSystemReady) {
      window.fs = {
        list: readDir,
        readFile: readFile,
        writeFile: writeFile,
        updateFile: updateFile,
        deleteFile: deleteFile,
        makeDir: makeDir,
        getFullPath: getFullPath,
        getBasePath: getBasePath,
        clearStorage: clearStorage,
        setClearStorage: setClearStorage,
      };

      window.git = {
        add: git_add,
        commit: git_commit,
        push: git_push,
        add_commit_push: git_add_commit_push,
        clone: git_clone,
        status: git_status,
        remove: git_remove,
        get_last_commit_hash: git_get_last_commit_hash,
      };
    }
  }, [isFileSystemReady]);

  const path = (p: string) => {
    return (p.indexOf("/") === 0 ? "" : "/") + p;
  };

  const pathGenerator = (path: string) => {
    path === "/" && (path = "");
    return path.indexOf(base_path) === 0
      ? path
      : `${base_path}${path.indexOf("/") === 0 ? "" : "/"}${path}`;
  };

  const getBasePath: () => string = () => {
    return base_path;
  };

  const getFullPath: (param1: string) => string = (path: string) => {
    return pathGenerator(path);
  };

  const makeDir = async (directory: string) => {
    const dirPath = pathGenerator(directory);
    if (s3Storage) {
      return;
    }
    return new Promise<string>(async (resolve, reject) => {
      const parentPath = nodepath.dirname(dirPath);
      try {
        await LFS.promises.stat(parentPath);
      } catch (err: any) {
        if (err.code === "ENOENT") {
          try {
            await makeDir(parentPath);
          } catch (err) {
            reject(err);
            return;
          }
        } else {
          reject(err);
          return;
        }
      }

      try {
        await LFS.promises.stat(dirPath);
        resolve(dirPath);
      } catch (err: any) {
        if (err.code === "ENOENT") {
          try {
            await LFS.promises.mkdir(dirPath);
            resolve(dirPath);
          } catch (err) {
            reject(err);
          }
        } else {
          reject(err);
        }
      }
    });
  };

  const writeFile = async (
    filepath: string,
    content: string,
    rewrite = true,
    addtogit = true
  ) => {
    if (s3Storage) {
      writeProjectFile(path(filepath), content);
      return;
    }

    let filePath = pathGenerator(filepath);

    if (window.fileSystemReady) {
      setInProcess(true);
    }

    return new Promise<boolean>(async (resolve, reject) => {
      try {
        const parentPath = nodepath.dirname(filePath);
        await makeDir(parentPath);

        if (!rewrite) {
          try {
            await LFS.promises.stat(filePath);
            resolve(false);
            return;
          } catch (err: any) {
            if (err.code !== "ENOENT") {
              reject(err);
            }
          }
        }

        LFS.writeFile(filePath, content, "utf8", (err) => {
          if (err) {
            reject(err);
          } else {
            resolve(true);
          }
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  const readFile = async (filepath: string) => {
    if (s3Storage) {
      const file = readProjectFile(path(filepath));
      if (file !== undefined) {
        return file;
      }
    }
    const filePath = pathGenerator(filepath);
    return new Promise<string | null>(async (resolve, reject) => {
      try {
        const data = (await LFS.promises.readFile(filePath, "utf8")) as string;
        resolve(data);
      } catch (error: any) {
        if (error.code !== "ENOENT") {
          reject(error);
          return;
        } else {
          resolve(null);
        }
      }
    });
  };

  const readDir = async (filepath: string) => {
    if (s3Storage) {
      const files = listProjectFiles(path(filepath));
      if (files !== undefined) {
        return files;
      }
    }
    const filePath = pathGenerator(filepath);
    return new Promise<string[] | null>(async (resolve, reject) => {
      try {
        const data = (await LFS.promises.readdir(filePath)) as string[];
        resolve(data);
      } catch (error: any) {
        if (error.code !== "ENOENT") {
          reject(error);
          return;
        } else {
          resolve(null);
        }
      }
    });
  };

  const updateFile = async (filepath: string, content: string) => {
    if (s3Storage) {
      writeProjectFile(path(filepath), content);
      return;
    }
    if (window.fileSystemReady) {
      setInProcess(true);
    }

    const filePath = pathGenerator(filepath);
    return new Promise<string>(async (resolve, reject) => {
      try {
        await LFS.promises.du(filePath);
        await LFS.promises.writeFile(filePath, content, "utf8");
      } catch (error) {
        reject(error);
      }
    });
  };

  const deleteFile = async (path: string) => {
    const filePath = pathGenerator(path);
    if (s3Storage) {
      deleteProjectFile(path);
      return;
    }
    return new Promise<null>(async (resolve, reject) => {
      try {
        try {
          const stat = await LFS.promises.stat(filePath);
          if (stat.isDirectory()) {
            await LFS.promises.rmdir(filePath);
            resolve(null);
            return;
          } else {
            await LFS.promises.unlink(filePath);
            git_remove(path);
            resolve(null);
            return;
          }
        } catch (error: any) {
          await LFS.promises.unlink(filePath);
          await git_remove(path);
          resolve(null);
          return;
        }
      } catch (err) {
        reject(err);
      }
    });
  };

  const deleteExceptEntries = async (path: string, except: string[]) => {
    const folderPath = path;
    return new Promise<null>(async (resolve, reject) => {
      try {
        const entries = await LFS.promises.readdir(path);
        for (const entry of entries) {
          if (!except.includes(entry)) {
            await LFS.promises.unlink(folderPath + entry);
          }
        }
        resolve(null);
      } catch (error: any) {
        if (error.code !== "ENOENT") {
          reject(error);
          return;
        } else {
          resolve(null);
        }
      }
    });
  };

  const deleteExpiredEntries = async (path: string, expired: number) => {
    const folderPath = path;
    return new Promise<null>(async (resolve, reject) => {
      try {
        const entries = await LFS.promises.readdir(path);
        for (const entry of entries) {
          const { ctimeMs } = await LFS.promises.stat(folderPath + entry);
          if (!isInTimeMs(ctimeMs, expired)) {
            await LFS.promises.unlink(folderPath + entry);
          }
        }
        resolve(null);
      } catch (error: any) {
        if (error.code !== "ENOENT") {
          reject(error);
          return;
        } else {
          resolve(null);
        }
      }
    });
  };

  const git_init = async () => {
    if (s3Storage) {
      return;
    }
    return new Promise<null>(async (resolve, reject) => {
      try {
        await git.init({
          fs: LFS,
          dir: base_path,
        });
        resolve(null);
      } catch (err) {
        reject(err);
      }
    });
  };

  const git_status = async (path: string | string[]) => {
    if (s3Storage) {
      return;
    }
    if (typeof path !== "string") {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const status = await git.statusMatrix({
            fs: LFS,
            dir: base_path,
            filepaths: path,
          });

          let statusString = "unmodified";
          let modifiedFiles: any[] = [];

          forEach(status, (item) => {
            if (item[1] !== 1 || item[2] !== 1 || item[3] !== 1) {
              statusString = "modified";
              modifiedFiles.push(item[0]);
            }
          });

          if (modifiedFiles.length > 0) {
            statusString = `modified`;
          }

          resolve({
            status: statusString,
            files: modifiedFiles,
          });
        } catch (err) {
          reject(err);
        }
      });
    }

    const filePath = _.replace(pathGenerator(path), base_path + "/", "");

    return new Promise<string>(async (resolve, reject) => {
      try {
        const status = await git.status({
          fs: LFS,
          dir: base_path,
          filepath: filePath,
        });
        resolve(status);
      } catch (err) {
        reject(err);
      }
    });
  };

  const git_remove = async (path: string) => {
    if (s3Storage) {
      return;
    }
    const filePath = _.replace(pathGenerator(path), base_path + "/", "");
    return new Promise<null>(async (resolve, reject) => {
      try {
        await git.remove({
          fs: LFS,
          dir: base_path,
          filepath: filePath,
        });
        resolve(null);
      } catch (err) {
        reject(err);
      }
    });
  };

  const git_add = async (path: string) => {
    if (s3Storage) {
      return;
    }
    const filePath = _.replace(pathGenerator(path), base_path + "/", "");

    return new Promise<null>(async (resolve, reject) => {
      try {
        const gitignore = await readFile(".gitignore");
        if (gitignore) {
          for (const item of gitignore.split("\n")) {
            if (item && _.startsWith(filePath, item)) {
              resolve(null);
              return;
            }
          }
        }

        if (filePath === "") {
          const entries = await LFS.promises.readdir(base_path);
          for (const entry of entries) {
            await git_add(entry);
          }
          resolve(null);
        } else {
          const fullFilePath = pathGenerator(filePath);

          const fileExists = await LFS.promises
            .stat(fullFilePath)
            .then(() => true)
            .catch(() => false);

          if (!fileExists) {
            await git.remove({
              fs: LFS,
              dir: base_path,
              filepath: filePath,
            });
          } else {
            await git.add({
              fs: LFS,
              dir: base_path,
              filepath: filePath,
            });
          }

          resolve(null);
        }
      } catch (err) {
        reject(err);
      }
    });
  };

  const git_clone = async (url: string, ref?: string) => {
    if (s3Storage) {
      return;
    }
    return new Promise<null>(async (resolve, reject) => {
      try {
        console.log("git clone", url);
        await git.clone({
          fs: LFS,
          http,
          dir: base_path,
          //corsProxy: (activeProxyServerAddress as string) || activeProxyServer,
          url,
          singleBranch: true,
          ref,
          depth: 1,
        });

        const files = await LFS.promises.readdir(base_path);
        console.log("git clone files", files);
        resolve(null);
      } catch (error: any) {
        console.log("git clone error", error);
        reject(error);
      }
    });
  };

  type gitUser = {
    name: string;
    email: string;
  };
  const git_commit = async (message?: string, gitUser?: gitUser) => {
    if (s3Storage) {
      return "";
    }
    let msg = message || `auto commit by riders`;

    return new Promise<string>(async (resolve, reject) => {
      try {
        const sha = await git.commit({
          fs: LFS,
          dir: base_path,
          message: msg,
          author: {
            name: gitUser?.name || "riders",
            email: gitUser?.email || "riders@riders.ai",
          },
        });
        resolve(sha);
      } catch (error) {
        reject(error);
      }
    });
  };

  const git_push = async (files: string[]) => {
    if (s3Storage) {
      return;
    }
    if (project.storage === "none" || user.id === undefined) {
      return;
    }

    if (project.storage === "s3") {
      return new Promise<null>(async (resolve, reject) => {
        try {
          const changes = [];

          for (const file of files) {
            const content = await readFile(file);
            const promis = storagePush(
              getCookie(accessTokenKey) as string,
              file,
              content
            );
            changes.push(promis);
          }

          await Promise.all(changes);
          resolve(null);
        } catch (error) {
          reject(error);
        }
      });
    }

    return new Promise<null>(async (resolve, reject) => {
      try {
        await git.push({
          fs: LFS,
          http,
          dir: base_path,
          remote: "origin",
          //corsProxy: activeProxyServer,
        });
        resolve(null);
      } catch (error) {
        reject(error);
      }
    });
  };

  const git_add_commit_push = async () => {
    if (s3Storage) {
      return;
    }
    return new Promise<string>(async (resolve, reject) => {
      try {
        await git_add("/");
        const sha = await git_commit("auto commit by riders");
        await git_push([]);
        resolve(sha);
      } catch (error: any) {
        reject(error);
      }
    });
  };

  const git_get_last_commit_hash = async () => {
    if (s3Storage) {
      return;
    }
    return new Promise<string>(async (resolve, reject) => {
      try {
        const sha = await git.resolveRef({
          fs: LFS,
          dir: base_path,
          ref: "HEAD",
        });
        resolve(sha);
      } catch (error: any) {
        reject(error);
      }
    });
  };

  const git_get_last_commit_info = async () => {
    if (s3Storage) {
      return { sha: "", message: "" };
    }
    return new Promise<{ sha: string; message: string }>(
      async (resolve, reject) => {
        try {
          const log = await git.log({
            fs: LFS,
            dir: base_path,
            depth: 1, // Sadece son commit'i getir
          });

          if (log.length === 0) {
            return reject(new Error("No commits found"));
          }

          const lastCommit = log[0]; // Son commit bilgisi

          resolve({
            sha: lastCommit.oid, // Commit Hash
            message: lastCommit.commit.message, // Commit Mesajı
          });
        } catch (error: any) {
          reject(error);
        }
      }
    );
  };

  //todo rewrite
  const publish_branch = async (message: string) => {
    messageApi.open({
      key: "publish",
      type: "loading",
      content: <FormattedMessage id="branchPublishing" />,
      duration: 60,
      className: "messagebox",
    });

    try {
      await publishBranch(getCookie(accessTokenKey) as string, message);
      messageApi.open({
        key: "publish",
        type: "success",
        content: <FormattedMessage id="branchPublished" />,
        duration: 2,
        className: "messagebox",
      });
    } catch (error) {
      messageApi.open({
        key: "publish",
        type: "error",
        content: <FormattedMessage id="branchNotPublished" />,
        duration: 2,
        className: "messagebox",
      });
    }
  };

  const gitSyncHandler = async (
    folders: string[],
    withPush: boolean = false
  ) => {
    if (s3Storage) {
      return;
    }
    return new Promise<any>(async (resolve, reject) => {
      const { status, files } = await git_status(folders);

      console.log(files);

      if (files.includes(".editor/layouts.yaml")) {
        console.log("layouts.yaml changed");
        const yamlO = await readFile(".editor/layouts.yaml");
        if (yamlO) {
          const data =
            yaml.load(yamlO) ||
            ({
              screens: [],
            } as any);
          setContentEditMode(true);
          setYamlData(data);
        }
      }

      if (files.some((file: string) => file.includes(".editor"))) {
        setDocumentRefreshKey(uuidv4());
      }

      if (status !== "unmodified") {
        let message = `auto commit by riders`;

        if (!isBranchOwner) {
          const modified = files.filter((file: string) =>
            file.includes("usercode")
          );

          if (modified.length > 0) {
            const [_, _username, filesString] = (
              await git_get_last_commit_info()
            ).message.split(":");
            const f = filesString?.split(",") || [];

            console.log(f);
            console.log(modified);

            const newFiles = new Set([
              ...f.map((i) => i.trim()),
              ...modified.map((i: string) => i.trim()),
            ]);

            message = `_${moment().unix()}:${project.session_user_name
              }:${Array.from(newFiles).join(",")}`;
          }
        }
        await git_add("/");
        const sha = await git_commit(message);

        if (withPush && project.storage !== "none") {
          await git_push(files);
        }

        setLastCommitHash(sha);

        setInProcess(false);
        console.log("Git Synced: " + new Date().toLocaleString());

        resolve({
          status: "modified",
          hash: sha,
          files: files,
        });
      } else {
        setInProcess(false);
        resolve({
          status: "unmodified",
          hash: lastCommitHash,
          files: [],
        });
      }
    });
  };

  const resetOverrides = async (): Promise<null> => {
    try {
      try {
        await deleteFile(".editor");
      } catch (error) {
        console.log("deleteFile error:", error);
      }

      const configResponse = await fetch(
        `${process.env.REACT_APP_CDN_URL}/content/internal/${contentId}/config.json`
      );

      if (configResponse.ok) {
        const configResp = await configResponse.json();
        await writeFile(
          ".editor/config.json",
          JSON.stringify(configResp, null, 2),
          true
        );
      } else {
        await writeFile(
          ".editor/config.json",
          JSON.stringify(config, null, 2),
          true
        );
      }

      const layoutResponse = await fetch(
        `${process.env.REACT_APP_CDN_URL}/content/internal/${contentId}/layouts.yaml`
      );
      if (!layoutResponse.ok) {
        throw new Error("Network response was not ok (layouts.yaml)");
      }
      const layoutData = await layoutResponse.text();

      await writeFile(".editor/layouts.yaml", layoutData, true);

      const fetchDocument = async (relativePath: string): Promise<string> => {
        const response = await fetch(
          project.documentationUrl.replace("index.html", relativePath)
        );
        if (!response.ok) {
          throw new Error("Network response was not ok (fetchDocument)");
        }
        const data = await response.text();
        return data.replace(
          /src="\.\//g,
          `src="${project.documentationUrl.replace(
            "index.html",
            relativePath.replace(/[^/]*$/, "")
          )}`
        );
      };

      const setDocumentsFromCell = async (cell: any) => {
        if (cell.type !== "Documentation") return;

        if (cell.relativePath) {
          try {
            const data = await fetchDocument(cell.relativePath);
            await writeFile(`.editor/${cell.relativePath}`, data, true);
          } catch (error) {
            console.error("setDocumentsFromCell error:", error);
          }
        }
        if (cell.relativePathEn) {
          try {
            const data = await fetchDocument(cell.relativePathEn);
            await writeFile(`.editor/${cell.relativePathEn}`, data, true);
          } catch (error) {
            console.error("setDocumentsFromCell error:", error);
          }
        }
      };

      const jsonData = yaml.load(layoutData) as any;

      const promises: Promise<void>[] = [];

      jsonData.chapters.forEach((chapter: any) => {
        chapter.cells.forEach((cell: any) => {
          promises.push(setDocumentsFromCell(cell));
        });
        chapter.subchapters.forEach((sub: any) => {
          sub.cells.forEach((cell: any) => {
            promises.push(setDocumentsFromCell(cell));
          });
        });
      });

      await Promise.all(promises);

      console.log("Overrides Resetted");
      return null;
    } catch (err) {
      const yamlContent = yaml.dump({
        namePrefix: "Projeniz:",
        namePrefixEn: "Your Project:",
        name: "Projenizi Oluşturun",
        nameEn: "Create Your Project",
        chapters: [
          {
            name: "Proje Ayarlarınızı Yapın",
            nameEn: "Set Your Project Settings",
            cells: [
              {
                type: "Documentation",
                relativePath: "htmls/TUR/1.html",
                relativePathEn: "htmls/ENG/1.html",
              },
            ],
            subchapters: [
              {
                name: "Yeni Ekran",
                nameEn: "New Screen",
                icon: "code",
                cells: [
                  {
                    type: "Documentation",
                    relativePath: "htmls/TUR/2.html",
                    relativePathEn: "htmls/ENG/2.html",
                  },
                  {
                    type: "Simulation",
                    sourceCode: "user_code4",
                    module: "Xrider_v3_Production#hotRiderFinal#4",
                  },
                ],
              },
            ],
          },
        ],
      });
      await writeFile(".editor/layouts.yaml", yamlContent, true);
      console.error("resetOverrides error:", err);
      return null;
    }
  };

  (window as any).resetOverrides = resetOverrides;

  const pushFileS3 = async (project: string, file: string) => {
    try {
      const fileAddress = file.replace("/.editor/", "");
      const content = await readFile(file);
      await pushFileToS3(
        "jOq82PLQZGi8boa9Mvx4nUjPAP",
        `/content/internal/${project}/${fileAddress}`,
        content || "",
        fileAddress.includes(".html")
          ? "text/html"
          : fileAddress.includes(".yaml")
            ? "text/yaml"
            : fileAddress.includes(".json")
              ? "application/json"
              : "text/plain"
      );
    } catch (error) {
      console.error("pushFile error:", error);
    }
  };

  (window as any).pushFile = pushFileS3;

  return (
    <FileContext.Provider
      value={{
        readFile,
        readDir,
        writeFile,
        updateFile,
        deleteFile,
        git_status,
        git_clone,
        git_get_last_commit_hash,
        git_remove,
        git_add,
        git_commit,
        publish_branch,
        isFileSystemReady,
        getFullPath,
        getBasePath,
        clearStorage,
        setClearStorage,
        lastCommitHash,
        setLastCommitHash,
        git_push,
        gitSyncHandler,
        inProcess,
        debounceGitSyncHandler,
        documentRefreshKey,
        resetOverrides,
        pushFileS3,
        leaveHandler,
      }}
    >
      {contextHolder}
      {notsContextHolder}
      {children}
    </FileContext.Provider>
  );
};

FileSystem.context = FileContext;
